export default "__VITE_ASSET__DoJOn5Ns__"